import { PreCollection } from '../pre-collection/pre-collection.model';
import { Chapter } from '../question/question.model';
import { Subject } from '../subject/subject.model';

export enum PaperGeneratedStatus {
  Pause = 'Pause',
  Published = 'Published',
  draft = 'Draft',
}
export interface PaperGenerated {
  id: number;
  name: string;
  subject: Subject;
  form: number;
  chapter: Chapter;
  isOriginal: boolean;
  preCollection: PreCollection;
  status: PaperGeneratedStatus;
}
